import { useState } from "react";
import { useHistory } from "react-router";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { PROPERTY_TYPE_VALUES } from "@/api/mappings/property";
import { PropallyApiFactory } from "@/module/CustomApiFactory";
import { PropertyManagementDetailSnackbarState, useRequestInitialLoading } from "@/view_models/atoms";
import { SelectedProperty } from "@/view_models/propertySelectors";

export const useDeleteMonthlyCashflowResult = () => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const requestInitialLoading = useRequestInitialLoading();
  const selected_property = useRecoilValue(SelectedProperty);
  const setManagementDetailSnackBarState = useSetRecoilState(PropertyManagementDetailSnackbarState);

  const deleteMonthlyCashflowResult = async (month: string, fieldsToDelete: Record<string, null>) => {
    setLoading(true);
    const fp = PropallyApiFactory();

    try {
      const deleteData = { month, ...fieldsToDelete };

      const response = await fp.v1PropertiesPropertyIdMonthlyCashflowResultsPatch(selected_property.id, deleteData, {
        withCredentials: true,
      });

      if (response.status === 200) {
        requestInitialLoading();
        setManagementDetailSnackBarState({
          message: "削除完了しました",
          status: "success",
          isOpen: true,
        });
      }
    } catch (e) {
      setManagementDetailSnackBarState({
        message: "物件情報を変更できませんでした",
        status: "error",
        isOpen: true,
      });
      if (selected_property.property.property_type === PROPERTY_TYPE_VALUES.consideration) {
        history.push("/management/consideration/detail");
      } else {
        history.push("/management/own/detail");
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    deleteMonthlyCashflowResult,
    loading,
  };
};
